
import { ElMessage } from "element-plus";
import { getEnum, login } from "@/api/index";
 
import { useStore } from "vuex";
import { ElForm } from "element-plus";

import { putRecruit ,getAllRecruitType } from "@/api/backstage";
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增招聘",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
 
  emits: ["close"],
  setup(opt, contex) {
    const ruleFormRef = ref(ElForm);
    let isEdit = false;
    let show = opt.open;
    const store = useStore();

    const dataMap: any = reactive({
      posType:'',
      ruleForm: {
        title: "",
        postTypeId: "",
        description:'',
        urgencyStatus:false,
        wages:'',
        sortNum:'',
        linkUrl:"",
      },
      rules: {
        title: [
          { required: true, message: "请输入场景名称", trigger: "blur" },
        ],
        postTypeId: [
          { required: true, message: "请选择招聘类型", trigger: "blur" },
        ],
        linkUrl: [
          { required: true, message: "请输入跳转链接", trigger: "blur" },
          { pattern: /^((ht|f)tps?):\/\/[\w-]+(\.[\w-]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?$/, message: "请输入正确的URL地址", trigger: "blur",},
        
        ],
      },

      async getRecruitType() {
        const res = await getAllRecruitType();
         dataMap.posType = res?.data ?? [];
      },

      async putNewData() {
        let query: any = JSON.parse(JSON.stringify(dataMap.ruleForm));
        query.urgencyStatus?query.urgencyStatus=1:query.urgencyStatus=0;
        const res = await putRecruit(query);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          contex.emit("close", false);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });

 
    if (opt.row) {
      isEdit = true;
      dataMap.ruleForm = opt.row;
      if(opt.row.urgencyStatus === 1 ){
        dataMap.ruleForm.urgencyStatus = true;
      }else{
        dataMap.ruleForm.urgencyStatus= false;
      }
      
    }

    const submitForm = () => {
      const form = unref(ruleFormRef);
      form.validate((valid: any) => {
        if (valid) {
          dataMap.putNewData();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    const close = () => {
      const form = unref(ruleFormRef);
      contex.emit("close", false);
    };

    const onSuccess = (val: any) => {
      dataMap.ruleForm.fileId = val.id;
      dataMap.ruleForm.fileName = val.fileName;
    };

 

    onMounted(() => {
      dataMap.getRecruitType();
    });

    return {
      show,
      store,
      isEdit,
      ruleFormRef,
      submitForm,
      onSuccess,
      close,
      ...toRefs(dataMap),
    };
  },
});
